// What a route shows: the screen's page inside RequirePermission (so a deep link by URL is guarded too).
import { RequirePermission } from './RequirePermission'
import type { Screen } from './screens'

export function ScreenElement({ screen }: { screen: Screen }) {
  const Page = screen.page
  return (
    <RequirePermission need={screen.need}>
      <Page />
    </RequirePermission>
  )
}
